"use strict";

var formatPrice = require('./formatPrice');

var toLocaleCurrency = require('./toLocaleCurrency');

function currency(input, data, fixed) {
  return toLocaleCurrency(data.currencyCode, parseFloat(input), fixed);
}

module.exports = {
  currency: currency,
  currencyFixed: function currencyFixed(input, data) {
    return currency(input, data, true);
  },
  groupDigits: function groupDigits(input) {
    return formatPrice(input);
  },
  titlecase: function titlecase(input) {
    return input.split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  },
  uppercase: function uppercase(input) {
    return input.toUpperCase();
  }
};